<script setup lang="ts">
import { UiText, UiIcon, UiAvatar } from "@shopexperts/shared";
import type { CompactUser } from "@shopexperts/legacy-api";

defineProps<{
  note: string;
  admin: CompactUser | null;
  adminLabel: string | null;
}>();
</script>

<template>
  <div class="rounded-md border border-amber-200 bg-amber-50 px-3 py-2">
    <div class="flex items-center gap-1.5">
      <UiIcon name="lock" class="h-3.5 w-3.5 shrink-0 text-amber-600" />
      <UiText as="span" variant="caption" class="text-amber-700" text="Internal note (admin only)" />
    </div>
    <UiText as="p" variant="small" :text="note" class="mt-1 text-se-dark" />
    <div v-if="adminLabel" class="mt-1 flex items-center gap-1.5 text-amber-700">
      <UiText as="span" variant="caption-normal" class="text-amber-700" text="Added by" />
      <span class="inline-flex min-w-0 items-center gap-1">
        <UiAvatar
          v-if="admin"
          :name="admin.name ?? admin.email ?? undefined"
          :url="admin.avatar ?? undefined"
          size="inline"
          :responsive="false"
          color-coded
        />
        <UiText
          as="span"
          variant="caption-normal"
          :text="adminLabel"
          class="min-w-0 truncate font-semibold text-amber-700"
        />
      </span>
    </div>
  </div>
</template>
